export enum CompareDateMode {
  Full = 0,
  JustDate = 1,
  JustTime = 2,
}
